import { Button } from '@/components/atoms/Button';
import { Box, Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardContainer = styled(Card)(({ theme }) => ({
  width: '100%',
  // minWidth: '360px',
  maxWidth: '380px',
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.spacing(1.5),
  pointerEvents: 'auto',
}));

export const CardHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.gray[100],
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
}));

export const CardContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  textAlign: 'center',
}));

export const CardInfoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: '1fr 1fr',
  gap: theme.spacing(1),
}));

export const CardInfoItem = styled(Box)(({ theme }) => ({
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(0.5),
}));

export const CardButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.states.outiliedBorder}`,
  color: theme.palette['mint-green'][800],
  height: '36px',
}));
